<template>
  <h1 :class="[$style.title, color === 'light' ? $style.light : '']" v-html="title"></h1>
</template>

<script>
export default {
  props: ['title', 'color']
}
</script>


<style module lang="scss">
@import "~sass-mq/mq";

.title {
  font-size: font-size(50px);
  color: transparent;
  -webkit-text-stroke: 1px rgba(white, 0.18);
  letter-spacing: 1px;
  margin: 50px 0 0 0;

  @include mq(sm) {
    margin: 0;
    font-size: 5.5rem;
  }

  @include mq(md) {
    font-size: 7.5rem;
    letter-spacing: 2px;
  }

  @include mq(ds) {
    font-size: font-size(xxl);
  }

  &.light {
    -webkit-text-stroke: 1px #3C3C3B;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GiantTitle.vue